<script lang="ts">
  import { animateTabSelection } from '../../game/motion';

  interface TabOption {
    id: string;
    label: string;
    disabled?: boolean;
  }

  interface Props {
    options: readonly TabOption[];
    value: string;
    label: string;
    onchange: (value: string) => void;
    class?: string;
  }

  let { options, value, label, onchange, class: className = '' }: Props = $props();

  function moveFocus(event: KeyboardEvent): void {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const current = event.currentTarget as HTMLButtonElement;
    const tabs = [
      ...(current.parentElement?.querySelectorAll<HTMLButtonElement>('[role="tab"]') ?? []),
    ].filter((tab) => !tab.disabled);
    if (tabs.length === 0) return;

    event.preventDefault();
    const currentIndex = Math.max(0, tabs.indexOf(current));
    const nextIndex =
      event.key === 'Home'
        ? 0
        : event.key === 'End'
          ? tabs.length - 1
          : (currentIndex + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[nextIndex]?.focus();
    tabs[nextIndex]?.click();
  }
</script>

<div class="tabs {className}" role="tablist" aria-label={label} use:animateTabSelection={{ value }}>
  {#each options as option (option.id)}
    <button
      type="button"
      class="tab"
      role="tab"
      data-tab-id={option.id}
      aria-selected={value === option.id}
      tabindex={value === option.id ? 0 : -1}
      disabled={option.disabled}
      onclick={() => onchange(option.id)}
      onkeydown={moveFocus}>{option.label}</button
    >
  {/each}
</div>
